import { SERVICE_QUANTIFIERS } from '~/types/api/drafts-search';
import { nameSegment, summarizeServiceConditions } from '../../summarizeServicePredicate';
export const collectionOperatorLabel = (quantifier, t)=>quantifier === 'none' ? t.operatorExclude() : t.operatorInclude();
const summarizeNestedServices = (services, t)=>SERVICE_QUANTIFIERS.map((quantifier)=>services[quantifier]).filter((predicate)=>predicate != null).map((predicate)=>summarizeServiceConditions(predicate, t)).filter((summary)=>summary !== '').join(', ');
const summarizeNameOrArm = (arms, t)=>arms.map((arm)=>nameSegment(arm.name)).filter((segment)=>segment != null).join(" ".concat(t.orConnector(), " "));
export const summarizeCollectionPredicate = (predicate, t)=>{
    const segments = [];
    const name = nameSegment(predicate.name);
    if (name != null) segments.push(name);
    if (predicate.services != null) {
        const serviceSummary = summarizeNestedServices(predicate.services, t);
        if (serviceSummary !== '') segments.push(serviceSummary);
    }
    if (predicate.or != null && predicate.or.length > 0) {
        const orSummary = summarizeNameOrArm(predicate.or, t);
        if (orSummary !== '') segments.push(orSummary);
    }
    return segments.join(', ');
};
